webpackJsonp([234785843380380,169478117574051],{

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _TitleSizes = __webpack_require__(202);
	
	var _TitleSizes2 = _interopRequireDefault(_TitleSizes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Title',
	  components: {
	    Title: _reactCore.Title
	  },
	  enumValues: {
	    'Object.values(TitleSize)': Object.values(_reactCore.TitleSize)
	  },
	  examples: [{ component: _TitleSizes2.default, title: 'Title Sizes' }]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TitleSizes = function (_React$Component) {
	  _inherits(TitleSizes, _React$Component);
	
	  function TitleSizes() {
	    _classCallCheck(this, TitleSizes);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TitleSizes.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactCore.Title,
	        { size: '4xl' },
	        '4xl Title'
	      ),
	      _react2.default.createElement(
	        _reactCore.Title,
	        { size: '3xl' },
	        '3xl Title'
	      ),
	      _react2.default.createElement(
	        _reactCore.Title,
	        { size: '2xl' },
	        '2xl Title'
	      ),
	      _react2.default.createElement(
	        _reactCore.Title,
	        { size: 'xl' },
	        'xl Title'
	      ),
	      _react2.default.createElement(
	        _reactCore.Title,
	        { size: 'lg' },
	        'lg Title'
	      ),
	      _react2.default.createElement(
	        _reactCore.Title,
	        { size: 'md' },
	        'md Title'
	      )
	    );
	  };
	
	  return TitleSizes;
	}(_react2.default.Component);
	
	exports.default = TitleSizes;
	TitleSizes.__docgenInfo = {
	  'description': '',
	  'displayName': 'TitleSizes'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Title } from '@patternfly/react-core';\n\nclass TitleSizes extends React.Component {\n  render() {\n    return (\n      <React.Fragment>\n        <Title size=\"4xl\">4xl Title</Title>\n        <Title size=\"3xl\">3xl Title</Title>\n        <Title size=\"2xl\">2xl Title</Title>\n        <Title size=\"xl\">xl Title</Title>\n        <Title size=\"lg\">lg Title</Title>\n        <Title size=\"md\">md Title</Title>\n      </React.Fragment>\n    );\n  }\n}\n\nexport default TitleSizes;\n"

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.title_package = exports.title_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleDocs = __webpack_require__(549);
	
	var _TitleDocs2 = _interopRequireDefault(_TitleDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'TitleSizes', path: '../../react-core/src/components/Title/examples/TitleSizes.js', file: __webpack_require__(448) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var title_docs = exports.title_docs = _TitleDocs2.default;
	var title_package = exports.title_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _TitleDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-title-docs-js-0b9582c5d5c6ae8d320b.js